import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';
import adminApi from '../utils/adminRequest';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await adminApi.post('/api/v1/admin/login', { email, password });
      const data = response.data;

      if (data.success) {
        localStorage.setItem('admin_user', JSON.stringify(data.data.user));
        localStorage.setItem('admin_token', data.data.access_token);
        navigate('/sys-portal/dashboard');
      } else {
        setError(data.detail || data.message || '登录失败');
      }
    } catch (err) {
      console.error('登录错误:', err);
      setError(err.response?.data?.detail || err.response?.data?.message || '网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h1>职唛AI管理后台</h1>
          <p>管理员登录</p>
        </div>
        
        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="email">邮箱</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入管理员邮箱"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">密码</label>
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <input
                type={isPasswordVisible ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="请输入密码"
                required
                style={{ width: '100%', paddingRight: '40px' }}
              />
              <button
                type="button"
                onMouseEnter={() => setIsPasswordVisible(true)}
                onMouseLeave={() => setIsPasswordVisible(false)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '5px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {isPasswordVisible ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? '登录中...' : '登录'}
          </button>
        </form>
        
        <div className="admin-login-footer">
          <p>© 2025 Zhimai AI. Internal Use Only.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
